module.exports = __webpack_public_path__ + "img/location-2-upcoming.b9ceae6d.png";